import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import AvatarUploader from '@blade/common/components/avatar-uploader.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import { handleError } from '@blade/common/utils/handle-error';
import EditMessages, { CreateStaff } from '@blade-sxp/pass/lang/edit';
import { merge, omit } from 'lodash';
import moment from 'moment';
import GenderSelect from '@blade-sxp/pass/components/gender-select.vue';
import { overlapGroup } from '@blade-sxp/pass/utils/overlap-group';
import EncryptInput from '@blade/common/components/encrypt-input.vue';
let default_1 = class default_1 extends Vue {
    title = '';
    remoteAvatarURL = '';
    currId = 'CREATE';
    form = {
        name: '',
        expirationTime: '',
        gender: '',
        portraitLibIds: [],
        purpose: '',
        countryId: '',
        phone: '',
        department: '',
        company: '',
        email: '',
        icCard: '',
        birthDay: '',
        receiver: '',
        identityId: '',
        image: '',
        personGroup: EType.GUEST,
        time: [],
        startTime: '',
    };
    tags = [
        { name: 'Tag 1', key: 0 },
        { name: 'Tag 2', key: 1 },
        { name: 'Tag 3', key: 2 },
        { name: 'Tag 4', key: 3 },
        { name: 'Tag 5', key: 4 },
    ];
    avatar = '';
    options = [{ label: 'staff1', value: '11' }];
    id = '';
    setDates(time) {
        this.form.startTime = moment(time[0] || new Date())
            .hour(0)
            .minute(0)
            .second(0)
            .format('YYYY-MM-DD HH:mm:ss');
        this.form.expirationTime = moment(time[1] || new Date())
            .hour(23)
            .minute(59)
            .second(59)
            .format('YYYY-MM-DD HH:mm:ss');
    }
    get whitegroup() {
        return {
            name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.name) {
                        callback(new Error(this.$t('nameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            portraitLibIds: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (this.form.portraitLibIds.length === 0) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            image: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!this.form.image) {
                        callback(new Error(this.$t('imageError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
            time: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (this.form.time.length === 0) {
                        callback(new Error(this.$t('timeError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClose(e) {
        console.log('e:', e);
    }
    handleDelete() {
        this.tags = [];
    }
    handleAvatar(url) {
        this.form.image = url;
    }
    async mounted() {
        const { meta, params } = this.$route;
        this.title = meta.page;
        this.id = params.id;
        await this.getPortraitIds();
        if (meta.page === 'editVisitor') {
            this.currId = 'EDIT';
            this.getData();
        }
    }
    async getPortraitIds() {
        try {
            const res = await StaffModule.getPortraitsGroup({ data: EType.GUEST, mode: this.currId });
            const mappedIds = this.mapOptions(res.data);
            this.options = mappedIds;
        }
        catch (e) { }
    }
    handleSubmit() {
        this.$refs['staff-form'].validate((valid) => {
            if (valid) {
                this.form.birthDay =
                    this.form.birthDay === '' || this.form.birthDay === null || this.form.birthDay === 'Invalid date'
                        ? ''
                        : moment(this.form.birthDay).format('YYYY-MM-DD');
                if (this.title === 'createVisitor') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async createStaff() {
        try {
            await StaffModule.createPasssstaff(omit(this.form, 'time'));
            this.$elmessage.success(this.$t('createSuccess').toString());
            this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    genderChange(v) {
        this.form.gender = v;
    }
    async updateStaff() {
        try {
            await StaffModule.updatePortrait({
                paramStaff: omit(this.form, 'time'),
                id: this.id,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'STAFF' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    mapOptions(data) {
        const res = data.map((item) => {
            return { label: item.name, value: item.libId };
        });
        return res;
    }
    async getData() {
        try {
            const res = await StaffModule.getPortraitById(this.id);
            const { data } = res;
            if (!data) {
                return;
            }
            const { phone, countryId, url, identityId } = data;
            if (url) {
                this.remoteAvatarURL = url;
            }
            this.form = {
                name: data.name,
                gender: data.gender,
                portraitLibIds: overlapGroup(data.portraitLibIds, this.options),
                expirationTime: data.expirationTime,
                phone,
                countryId: countryId.substr(0, 10),
                company: data.company,
                email: data.email,
                icCard: data.icCard,
                birthDay: data.birthDay,
                identityId,
                purpose: data.purpose,
                department: data.department,
                receiver: data.receiver,
                image: data.url,
                personGroup: EType.GUEST,
                time: [data.startTime, data.expirationTime],
                startTime: data.startTime,
            };
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'STAFF' } });
    }
};
__decorate([
    Watch('form.time')
], default_1.prototype, "setDates", null);
default_1 = __decorate([
    Component({
        name: 'CreatePortrait',
        components: { AvatarUploader, GenderSelect, EncryptInput },
        i18n: {
            messages: {
                'en-us': {
                    id: 'User id',
                    phone: 'Phone Number',
                    position: 'Position',
                    email: 'Email',
                    ic: 'IC Card',
                    address: 'Working Addr',
                    birthday: 'Birthday',
                    identity: 'ID Card',
                    upload: 'Please upload the portrait',
                    createVisitor: 'Create Visitor',
                    groupName: 'Group Name',
                    groupAccess: 'Group Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editVisitor: 'Edit Visitor',
                    name: 'Name',
                    gender: 'Gender',
                    whiteGroup: 'Visitor Group(Multiple Select)',
                    valid: 'Valid util',
                    visitpurpose: 'Visit purpose',
                    ppl: 'Reception',
                    nameError: 'Name is required',
                    groupError: 'Please input group',
                    imageError: 'Please input image',
                    startDate: 'Start date',
                    endDate: 'End date',
                    timeError: 'Please input time',
                },
                zh: {
                    id: '人员工号',
                    phone: '手机号',
                    position: '企业及职位',
                    email: '邮箱',
                    ic: 'IC卡号',
                    address: '工作地点',
                    birthday: '出生日期',
                    identity: '身份证号',
                    upload: '请上传人像',
                    createVisitor: '创建访客',
                    groupName: '人员组名称',
                    groupAccess: '人员组权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editVisitor: '编辑访客',
                    name: '姓名',
                    gender: '性别',
                    whiteGroup: '所属访客组（可多选）',
                    valid: '访问有效期',
                    visitpurpose: '访问目的',
                    ppl: '接待人',
                    nameError: '请填名字',
                    groupError: '请选人员组',
                    imageError: '请选头像',
                    startDate: '开始时间',
                    endDate: '结束时间',
                    timeError: '请输入访问时间',
                },
            },
            sharedMessages: merge({}, EditMessages, CreateStaff),
        },
    })
], default_1);
export default default_1;
